import React, { Fragment, useEffect, useState } from "react";
import { createSearchParams, Link } from "react-router-dom";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import "./style.scss";

const ContinueCreateInitiative = (props) => {

    const[initiative, SetInitiative] = useState(props.sentInitiative);

    useEffect(() => {
        
        if(props.sentInitiative.InitiativeID != initiative.InitiativeID)
        {
            SetInitiative(props.sentInitiative);
        }
    }, [props.sentInitiative])

    return (
        <Fragment>
            {
                initiative && initiative.InitiatorID == props.auth.user.UserID  &&
                <Link className={"continued-button " + props.className} to={{
                    pathname : '/create/describe'
                    ,search : `?${createSearchParams({
                        id : initiative.InitiativeID
                    })}`
                }}> <span className="label">Continue</span> <span className="value">Create {initiative.Title}</span></Link>
            }
        </Fragment>
    )
}

export default connect(stateMap)(ContinueCreateInitiative);